<template>
  <div>
    <management-integrations :grouped-locations="groupedLocations" />
  </div>
</template>

<script>
import ManagementIntegrations from 'src/components/Dashboard/Views/Integrations/ManagementIntegrations.vue'

export default {
  name: 'SettingsIntegrations',
  components: {
    ManagementIntegrations
  },
  computed: {
    groupedLocations () {
      const company = (this.$session && this.$session.get('selectedCompanyData')) || {}
      const locs = Array.isArray(company.locations_details) ? company.locations_details : []
      const groups = {}

      locs.forEach(loc => {
        const vat = loc.inv_fiscal_code || loc.vatNumber || 'Fără cod fiscal'
        if (!groups[vat]) groups[vat] = []
        groups[vat].push(loc)
      })

      return Object.entries(groups).map(([vat, locations]) => ({ vat, locations }))
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/SettingsIntegrations.vue